module.exports = __webpack_public_path__ + "img/1.3bcd9c32.svg";